export const AdvancedSearchTrackingEvent = {
    FunnelStepViewed: 'advanced_search_funnel_step_viewed',
    Edited: 'advanced_search_edited',
    Exit: 'advanced_search_exit',
    AutocontactOptedIn: 'advanced_search_autocontact_opted_in',
    CalibrationOptedIn: 'advanced_search_calibration_opted_in',
    Shortlisted: 'freelancer_shortlisted',
    Rejected: 'advanced_search_freelancer_rejected',
    AssistanceRequested: 'advanced_search_assistance_requested',
    SelectionSkipped: 'advanced_search_profile_selection_skipped',
    EmptyState: 'advanced_search_empty_state',
    CatalogPromptSelected: 'advanced_search_catalog_prompt_selected',
    ProfileViewed: 'profile_viewed',
    DisplayFullProfile: 'advanced_search_display_full_profile',
    SkillFreeTextEntered: 'advanced_search_skill_free_text_entered',
    DraftResume: 'advanced_search_draft_resume',
    SeeMoreProfiles: 'advanced_search_see_more_clicked',
    SubmitAdvancedSearchDisplayExplanation: 'temp_advanced_search_what_happens_next_clicked',
} as const;
